(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["claim-replacement-form"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var series = document.getElementById('series'),
      colorF = document.getElementById('colorField'),
      designF = document.getElementById('designField');

  series.addEventListener('change', function() {
    if (this.value == 'Core' || this.value == 'Striker') {
      colorF.style.display = 'block';
      designF.style.display = 'none';
    } else if (this.value == 'Vortex') {
      colorF.style.display = 'none';
      designF.style.display = 'block';
    } else {
      colorF.style.display = 'none';
      designF.style.display = 'none';
    }
  });

  var form = document.getElementById('claimForm');
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    var data = new FormData(form);
    fetch(form.action, {
      method: 'POST',
      body: data,
      headers: { 'Accept': 'application/json' }
    })
    .then(function(res) {
      if (res.ok) window.location.href = '/pages/thank-you';
      else alert('Submission failed, please try again.');
    })
    .catch(function() {
      alert('Network error, please try again.');
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
